import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-forms-summary',
  templateUrl: './forms-summary.component.html',
  styleUrls: ['./forms-summary.component.css']
})
export class FormsSummaryComponent implements OnInit {

  summaryItems: any[] = [];

  CaseWorkItemFormsId: string = 'SUMMARY_TEST';
  dataFormID: string = 'SUMMARY_TEST';

  saveEmitter: EventEmitter<any> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<FormsSummaryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    console.log('OPENED', this.data);

    this.summaryItems = this.data.summaryParagraph.items;
    console.log('SUMMARY ITEMS', this.summaryItems);
  }

  close() {
    this.dialogRef.close(true);
  }

}
